import "./styleservices.css";
import { Link } from "react-router-dom";

function AppServices() {
  return (
    <section className="services">
      <div className="skill-card">
        {serviceData.map((service, index) => (
          <div className="card-content" key={index}>
            <h3>{service.title}</h3>
            <p>
              <strong>{service.description}</strong>
            </p>
            <Link className="btn btn-primary btn-sm m-2" to="/Contact">
              Contact Us
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}

const serviceData = [
  {
    title: "INVENTORY MANAGEMENT",
    description:
      "Are you too busy to control your Stock and other Transactions, or you lack the expertise, or your business is in a different town, or you want to be on the same page with your partner because he is running the business on your behalf?Whatever the case might be, we have a solution for you. All you need to do is to outsource your working capital management to us.We will be providing you with periodic reports which will contain your stock balances, information about Sales revenue from one period to another, Gross profit, Expenses, Other incomes, Net profit, Cash flow anaylysis, purchases and other necessary reports. We will prepare your Income Statement, Balance Sheet and cash flow statement at the end of the year.Remember so many businesses fail due to lack of proper Internal Control and Audit failures, so please do not be a victim, know that without control you are nowhere.To have more information please contact us today.",
  },
  {
    title: "PROPERTY MANAGEMENT",
    description:
      "Entrust your property management to us! We ensure proper record-keeping, real-time transaction updates, and a tenant payment tracking application for easy monitoring.",
  },
  {
    title: "APPLICATION DEVELOPMENT",
    description:
      "We develop web and mobile applications to enhance your business operations, secure transactions, and provide a global digital presence for your company.",
  },
  {
    title: "AGENCY",
    description:
      "We advertise properties for owners and agents at reasonable rates. Contact us today to find buyers or tenants quickly.",
  },
];

export default AppServices;